<template>
  <div class="header">
    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/rentals')"
    >
      <router-link
        class="headerBtn"
        to="/rentals/calendar"
        :class="{
          'route-active': this.$route.path.startsWith('/rentals/calendar')
        }"
      >
        <h4>Calendar</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn"
        to="/rentals/list"
        :class="{
          'route-active': this.$route.path.startsWith('/rentals/list')
        }"
      >
        <h4>List</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="
        this.$route.path.startsWith('/listings') ||
        this.$route.path.startsWith('/rooms') ||
        this.$route.name == 'editProperty'
      "
    >
      <router-link
        class="headerBtn properties"
        to="/listings/properties"
        :class="{
          'route-active':
            this.$route.path.startsWith('/listings/properties') ||
            this.$route.name == 'editProperty'
        }"
      >
        <h4>Properties</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn"
        to="/listings/rooms"
        :class="{
          'route-active':
            this.$route.path.startsWith('/listings/rooms') ||
            this.$route.path.startsWith('/rooms/new')
        }"
      >
        <h4>Rooms</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/chores')"
    >
      <router-link
        class="headerBtn"
        to="/chores/calendar"
        :class="{
          'route-active': this.$route.path.startsWith('/chores/calendar')
        }"
      >
        <h4>Calendar</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn"
        to="/chores/list"
        :class="{ 'route-active': this.$route.path.startsWith('/chores/list') }"
      >
        <h4>Chores</h4>
        <div class="headerBtnBottom" />
      </router-link>
      <router-link
        class="headerBtn"
        to="/chores/notifications"
        :class="{
          'route-active':
            this.$route.path.startsWith('/chores/notifications') ||
            this.$route.name == 'NewNotificationScreen'
        }"
      >
        <h4>Notifications</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/report')"
    >
      <router-link
        class="headerBtn"
        to="/report"
        :class="{ 'route-active': this.$route.path.startsWith('/report') }"
      >
        <h4>Report</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/heatmap')"
    >
      <router-link
        class="headerBtn"
        to="/heatmap"
        :class="{ 'route-active': this.$route.path.startsWith('/heatmap') }"
      >
        <h4>Heatmap</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <div
      class="headerBtnContainer"
      v-if="this.$route.path.startsWith('/contacts')"
    >
      <router-link
        class="headerBtn"
        to="/contacts/housemates"
        :class="{ 'route-active': this.$route.path.startsWith('/contacts') }"
      >
        <h4>Housemates</h4>
        <div class="headerBtnBottom" />
      </router-link>
    </div>

    <!-- this is to add whitespace in case you dont want to show navigation buttons -->
    <!-- <div 
      v-if="this.$route.name == 'editProperty'"
      class="header-white-space"
    /> -->

    <div class="headerUserContainer" v-if="!smallDevice">
      <img
        v-if="user && user.photoURL"
        alt="User Icon"
        :src="user.photoURL"
        class="accountImage"
      />
      <div class="headerUserDataContainer">
        <div class="headerUserName" v-if="user">
          {{ user.displayName }}
        </div>
        <div class="headerUserEmail" v-if="user">
          {{ user.email }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from './../Firebase'

export default {
  name: 'Header',
  data() {
    return {
      user: null,
      smallDevice: false
    }
  },
  created() {
    this.getUserData()
    window.addEventListener('resize', this.onResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    getUserData() {
      auth.onAuthStateChanged((user) => {
        this.user = user
      })
    },

    onResize() {
      this.width = window.innerWidth
      if (this.width > 768) {
        this.smallDevice = false
      } else {
        this.smallDevice = true
      }
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  min-height: 70px;
}

.headerBtnContainer {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding-right: 25px;
  padding-left: 25px;
  background-color: white;
}

.headerBtnBottom {
  width: 40%;
  height: 3px;
  margin-top: 10px;
  background-color: white;
}
.headerBtn {
  font-family: Montserrat;
  padding-right: 16px;
  padding-left: 16px;
  font-size: 14px;
  width: 100px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #767675;
  cursor: pointer;
  text-decoration: none;
}

.headerBtn h4 {
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  font-weight: normal;
}

.route-active.headerBtn {
  color: var(--rentalios-dark);
}
.route-active .headerBtnBottom {
  background-color: var(--rentalios-dark);
}
.header .headerUserContainer {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  margin-left: auto;
}
.headerUserContainer .headerUserDataContainer {
  min-width: 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding-left: 10px;
}
.headerUserContainer .headerUserEmail {
  font-size: 12px;
  line-height: 16px;
  color: #a4a4a4;
}
.headerUserContainer .headerUserName {
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #192a3e;
}
.headerUserContainer .accountImage {
  width: 46px;
  height: 46px;
  border-radius: 25px;
}

.headerUserContainer > img {
  min-width: 46px;
  min-height: 46px;
}

div.header-white-space {
  min-width: 300px;
}

@media only screen and (max-width: 768px) {
  .header .headerUserContainer {
    visibility: hidden;
  }
}
</style>
